/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import swal from 'sweetalert';

import { finalPrice } from '../../../../../utils/prices';
import { pendingCredit } from '../../../../../services/cash';
import { findIndexOfObject } from '../../../../../utils/filters';
import { capitalizeWords, toCurrencyCop } from '../../../../../utils/strings';
import { useValidationCountry, useFetchIpData } from '../../../../../utils/validationCountry';

import Button from '../../../../../components/button';
import ContentSection from '../../../../../components/contentSection';
import StepProgressBar from '../../../../../components/stepProgressBar';

import { typeDelivery } from '../../../../../constants/general';

import './paymentMultipleShippings.scss';

const PaymentMultipleShippings = ({
  next, dataShippingsToPay, currentBalance, user, step, currentStep, setSection,
  loadingSendingGenerating, rechargeBalance, isMobileDevice, totalPriceNotifications,
  setStep, setCurrentStep,
}) => {
  const ipData = useFetchIpData();
  const isCountryValid = useValidationCountry(ipData.country);

  const [creditAvailable, setCreditAvailable] = useState(0);

  const getCredit = async () => {
    if (user) {
      const getPendingCredit = await pendingCredit(user._id)
        .then((response) => response[0]?.total || 0);
      setCreditAvailable(((user?.creditLimitCop || 0) - getPendingCredit));
    }
  };

  useEffect(() => {
    getCredit();
  }, []);

  const finalPriceCalculator = (shipping) => finalPrice(
    shipping.deliveryCompanySelected.shippingCost,
    shipping.collectionService,
    shipping.addShippingToCollectionValue,
    shipping.deliveryCompanySelected.collectionCommissionWithRate,
    shipping.deliveryCompanySelected.collectionCommissionWithOutRate,
  );

  const priceRealCostCalculator = (value) => finalPrice(
    value.deliveryCompanySelected.shippingRealCost,
    value.collectionService,
    value.addShippingToCollectionValue,
    value.deliveryCompanySelected.collectionCommissionWithRate,
    value.deliveryCompanySelected.collectionCommissionWithOutRate,
  );

  const totalToPayFromTheCollecion = () => (
    dataShippingsToPay.slice().filter((shipping) => (
      shipping.paymentMethod === 102
    )).map((shipping) => finalPriceCalculator(shipping)).reduce((a, b) => a + b, 0)
  );

  const totalToPayWithBalance = () => (
    dataShippingsToPay.slice().filter((shipping) => (
      shipping.paymentMethod === 101
    )).map((shipping) => finalPriceCalculator(shipping)).reduce((a, b) => a + b, 0)
  );

  const totalToPayFromCredit = () => (
    dataShippingsToPay.slice().filter((shipping) => (
      shipping.paymentMethod === 105
    )).map((shipping) => finalPriceCalculator(shipping)).reduce((a, b) => a + b, 0)
  );

  const totalToPay = () => (
    dataShippingsToPay.slice().map((shipping) => (
      finalPriceCalculator(shipping)
    )).reduce((a, b) => a + b, 0)
  );

  const totalToPayWithNotifications = () => (
    totalToPay() + (totalPriceNotifications * dataShippingsToPay.length)
  );

  const shippingsPerDeliveryCompany = () => {
    const deliveryCompanies = [];
    const totalShippings = dataShippingsToPay.length;
    dataShippingsToPay.slice().forEach((shipping) => {
      const indexToInsert = findIndexOfObject(shipping.deliveryCompanySelected.deliveryCompanyId, deliveryCompanies, 'deliveryCompanyId');
      if (indexToInsert >= 0) {
        deliveryCompanies[indexToInsert].numberOfShippings += 1;
        deliveryCompanies[indexToInsert].sendingValue += finalPriceCalculator(shipping);
        // eslint-disable-next-line max-len
        if (shipping.deliveryCompanySelected.shippingRealCost) { deliveryCompanies[indexToInsert].realCost += priceRealCostCalculator(shipping); }
      } else {
        deliveryCompanies.push({
          deliveryCompanyId: shipping.deliveryCompanySelected.deliveryCompanyId,
          deliveryCompanyImgUrl: shipping.deliveryCompanySelected.deliveryCompanyImgUrl,
          deliveryCompanyName: shipping.deliveryCompanySelected.deliveryCompanyName,
          numberOfShippings: 1,
          sendingValue: finalPriceCalculator(shipping),
          recaudoValue: shipping.paymentMethod === 102 ? finalPriceCalculator(shipping) : 0,
          // eslint-disable-next-line max-len
          ...shipping.deliveryCompanySelected.shippingRealCost && { realCost: priceRealCostCalculator(shipping) },
        });

        deliveryCompanies.forEach((company) => {
          company.notificationCost = (
            company.numberOfShippings / totalShippings) * totalPriceNotifications;
          company.averageShippingCost = company.sendingValue / company.numberOfShippings;
        });
      }
    });
    return deliveryCompanies;
  };

  const handleClick = () => {
    if ((totalToPayFromCredit() + totalPriceNotifications) > creditAvailable) {
      swal({
        title: 'Crédito insuficiente',
        text: 'No fue posible procesar el pago',
        icon: 'error',
        buttons: false,
        timer: 4000,
      });

      setTimeout(() => {
        setStep(2);
        setCurrentStep(2);
        setSection('sendingList');
      }, 4000);
    } else {
      next();
    }
  };

  return (
    <ContentSection>
      <div className="progressBar">
        <StepProgressBar
          steps={[{}, {}, {}, {}].map((item, index) => {
            const newItem = item;
            if (index < step) newItem.success = true;
            return newItem;
          })}
          currentStep={currentStep}
        />
      </div>
      <div id="multiple-shippings__payment" className={isMobileDevice ? 'mobile-mode' : 'desktop-mode'}>
        <div className="delivery-companies-list-and-details-container">
          <table className="general-table delivery-companies-list-and-details">
            {!isMobileDevice && (
              <thead>
                <tr>
                  <th className="title-th">
                    {capitalizeWords(typeDelivery[user.countryCode])}
                    s
                  </th>
                  <th className="title-th">Cantidad de envíos</th>
                  <th className="title-th">Valor de los envíos</th>
                  <th className="title-th">Valor a pagar con recaudo</th>
                  <th className="title-th">Valor a pagar por notificaciones</th>
                  <th className="title-th">Total</th>
                </tr>
              </thead>
            )}
            <tbody className="tbody-custom">
              {shippingsPerDeliveryCompany().map((item) => (
                <tr key={item.deliveryCompanyId}>
                  <td>
                    <div className="delivery-company">
                      <img src={item.deliveryCompanyImgUrl} alt="logo" />
                      <span>{item.deliveryCompanyName}</span>
                    </div>
                  </td>
                  <td>{item.numberOfShippings}</td>
                  <td>
                    <div className="prices">
                      <td className={item.realCost ? 'value' : null}>{toCurrencyCop(user, Math.floor(item.sendingValue))}</td>
                      {!Number.isNaN(Number(item.realCost)) && (<td className="real-cost">{toCurrencyCop(user, Math.floor(item.realCost))}</td>)}
                    </div>
                  </td>
                  <td>{toCurrencyCop(user, (item.recaudoValue * item.numberOfShippings))}</td>
                  <td>{toCurrencyCop(user, (totalPriceNotifications * item.numberOfShippings))}</td>
                  <td>
                    {toCurrencyCop(user, Math.floor(item.sendingValue)
                    + (totalPriceNotifications * item.numberOfShippings))}
                  </td>
                </tr>
              ))}
            </tbody>
            <tbody>
              <tr>
                <td>Total:</td>
                <td>{dataShippingsToPay.length}</td>
                <td>{toCurrencyCop(user, totalToPay())}</td>
                <td>{toCurrencyCop(user, totalToPayFromTheCollecion())}</td>
                <td>{toCurrencyCop(user, dataShippingsToPay.length * totalPriceNotifications)}</td>
                <td>{toCurrencyCop(user, totalToPayWithNotifications())}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="cash">
          <div>
            <div className="info">
              <div className="label">Tu saldo actual:</div>
              <div className={`value ${(totalToPay() + totalPriceNotifications) > currentBalance ? 'red' : 'blue'}`}>
                {toCurrencyCop(user, currentBalance)}
              </div>
            </div>
            <Button
              type="secondary"
              onClick={() => rechargeBalance()}
              text="Recargar saldo"
            />
          </div>
          <Button
            type={isCountryValid ? 'primary-mx' : 'quaternary'}
            onClick={() => {
              if (dataShippingsToPay[0].paymentMethod !== 105
                && ((totalToPayWithBalance() + totalPriceNotifications) <= currentBalance)) {
                next();
              } else if (
                (dataShippingsToPay[0].paymentMethod === 105)
              ) {
                handleClick();
              }
            }}
            className="flotant-button__payment-multiple-shippings"
            loading={loadingSendingGenerating}
            text="Pagar ahora"
            disabled={((totalToPayWithBalance() + totalPriceNotifications) > currentBalance)}
          />
        </div>

      </div>
    </ContentSection>
  );
};

PaymentMultipleShippings.propTypes = {
  next: PropTypes.func.isRequired,
  dataShippingsToPay: PropTypes.any.isRequired,
  currentBalance: PropTypes.number.isRequired,
  loadingSendingGenerating: PropTypes.bool.isRequired,
  rechargeBalance: PropTypes.func.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  totalPriceNotifications: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  setSection: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  businessFlags: state.globalData.businessFlags || [],
});

export default compose(
  connect(mapStateToProps),
)(PaymentMultipleShippings);
